import React from 'react';

type Props = {
  onClick: () => void;
  text: string;
};

function ButtonLink({ onClick, text }: Props) {
  return (
    <button
      type="button"
      onClick={() => onClick()}
      className="font-rp-pn-semi-bold leading-6 text-16 text-rp-primary-light-5"
    >
      {text}
    </button>
  );
}

export default ButtonLink;
